export default {
  stock_download_title: '證券交易平台下載',
  futures_download_title: '期貨交易平台下載',
  fx_Pro_download_title: 'Eddid FX Pro下載',
  fx_MT5_download_title: 'MetaTrader5(MT5)下載',
  stock_iOS: 'iOS',
  stock_Android: 'Android',
  stock_Microsoft: 'Microsoft',
  stock_web: '網頁版',
  stock_security_code_ios: '保安編碼(IOS)',
  stock_security_code_android: '保安編碼(Android)',
  stock_security_code: '保安編碼',
  fx_pro_for_iPhone: 'iOS',
  fx_pro_for_Android: 'Android',
  fx_pro_for_Windows_html: 'Windows (html)',
  fx_pro_for_Windows_java: 'Windows (java)',
  fx_pro_for_java: 'Java',
  fx_mt5_for_iPhone: 'iOS',
  fx_mt5_for_Android: 'Android',
  fx_mt5_for_Windows: 'Windows',
  fx_mt5_eddid_ios: 'EDDID賬戶雙重認證軟件（IOS）',
  fx_mt5_eddid_android: 'EDDID賬戶雙重認證軟件（Android）',
  futures_download: '交易平台下載',
  futures_use_download: '使用手冊下載',
  eddid_pro: 'Eddid Pro',
  eddid_lite: 'Eddid Lite'
}
